export default {
  en: {
    please_select_a_plan: 'Please select a plan',
    subscription_selected: 'Subscription selected',
    company_info_filled: 'Company information filled',
    register_info_filled: 'Register information filled',
    privacy_accepted_agb_accepted: 'Privacy and AGB accepted',
    confirm_subscription: 'Confirm subscription',
    invoice_address: 'Invoice address',
    register_info: 'Register information',
    legal_info: 'Legal information',
    duration: 'Subscription duration',
    fourteen_days_trial: '14 days free',
    after_that: 'after that',
    enter_your_company_name: 'Enter your company name',
    enter_your_street: 'Enter your street',
    enter_your_zip_code: 'Enter your ZIP code',
    enter_your_city: 'Enter your city',
    enter_your_country: 'Enter your country',
    enter_your_email: 'Enter your email',
    enter_your_password: 'Enter your password',
    i_accept_the_privacy_policy: 'I accept the privacy policy',
    i_accept_the_agb: 'I accept the AGB',
    check_privacy_policy: 'Check privacy policy',
    check_agb: 'Check AGB',
  },
  de: {
    please_select_a_plan: 'Bitte wählen Sie einen Plan',
    subscription_selected: 'Abonnement ausgewählt',
    company_info_filled: 'Firmeninformationen ausgefüllt',
    register_info_filled: 'Registrierungsinformationen ausgefüllt',
    privacy_accepted_agb_accepted: 'Datenschutz und AGB akzeptiert',
    confirm_subscription: 'Abonnement abschließen',
    invoice_address: 'Rechnungsadresse',
    register_info: 'Registrierungsinformationen',
    legal_info: 'Rechtliche Informationen',
    duration: 'Abo-Dauer',
    fourteen_days_trial: '14 Tage kostenlos',
    after_that: 'danach',
    enter_your_company_name: 'Gebe deinen Firmennamen ein',
    enter_your_street: 'Gebe deine Straße ein',
    enter_your_zip_code: 'Gebe deine Postleitzahl ein',
    enter_your_city: 'Gebe deine Stadt ein',
    enter_your_country: 'Gebe dein Land ein',
    enter_your_email: 'Gebe deine E-Mail-Adresse ein',
    enter_your_password: 'Gebe dein Passwort ein',
    i_accept_the_privacy_policy: 'Ich akzeptiere die Datenschutzrichtlinie',
    i_accept_the_agb: 'Ich akzeptiere die AGB',
    check_privacy_policy: 'Datenschutzrichtlinie anschauen',
    check_agb: 'AGBs anschauen',
  },
};
